import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3935d826&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=3935d826&scoped=true&lang=less&"
import style1 from "./home.vue?vue&type=style&index=1&id=3935d826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935d826",
  null
  
)

export default component.exports